import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { lg, md, xl } from '../common';

export function initIntegrations() {
  const parent = document.querySelector('.integrations');
  if (!parent) return;

  new Swiper('.integrations__swiper', {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: {
        slidesPerView: 2,
      },
      [lg]: {
        slidesPerView: 3,
      },
    },
  });

  const cards = [...parent.querySelectorAll('.integrations__card')];

  const mm = gsap.matchMedia();
  mm.add(`(max-width: ${md - 1}px)`, () => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: parent,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
      defaults: { ease: 'power3.out' },
    });
    tl.from('.integrations__graph img', {
      opacity: 0,
      scale: 0.6,
      duration: 1.3,
    });
    tl.from('.integrations__line2', { height: 0, duration: 0.7 }, '<');

    const card = cards[0];

    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    tl.to(
      card,
      {
        opacity: 1,
        scale: 1.02,
        duration: 1,
        ease: 'power1.out',
        delay: 0,
      },
      '-=1',
    );
    tl.to(card, {
      scale: 1,
      duration: 0.5,
      ease: 'power1.inOut',
    });
  });

  mm.add(`(min-width: ${md}px)`, () => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: parent,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
      defaults: { ease: 'power3.out' },
    });
    tl.from('.integrations__graph img', {
      opacity: 0,
      scale: 0.6,
      duration: 1.3,
    });
    tl.from('.integrations__line1', { width: 0, duration: 1.3 }, '-=1');
    tl.from('.integrations__line2', { height: 0, duration: 1.3 }, '<');
    cards.reverse().forEach((card, index) => {
      gsap.set(card, {
        opacity: 0,
        scale: 0.8,
        transformOrigin: 'center center',
      });

      tl.to(
        card,
        {
          opacity: 1,
          scale: 1.02,
          duration: 1,
          ease: 'power1.out',
          delay: index * 0.1,
        },
        '-=1.5',
      );
      tl.to(card, {
        scale: 1,
        duration: 0.5,
        ease: 'power1.inOut',
      });
    });
  });
}
